// src/components/global/Button.tsx
import React from "react";
import { StyledButton } from "./styled/Button.styled";

export interface ButtonProps {
  onClick?: () => void;
  children: React.ReactNode;
  type?: "button" | "submit" | "reset";
  className?: string;
  icon?: string;
  iconAlt?: string;
  variant?: "primary" | "secondary" | "outlined" | "text";
  fullWidth?: boolean;
  ariaLabel?: string;
  disabled?: boolean;
  tabIndex?: number;
  role?: string;
  "aria-controls"?: string;
  "aria-expanded"?: boolean;
  "aria-haspopup"?: boolean | "menu" | "dialog" | "listbox" | "tree" | "grid";
}

export function Button({
  onClick,
  children,
  type = "button",
  className = "",
  icon,
  iconAlt,
  variant = "primary",
  fullWidth = false,
  ariaLabel,
  disabled = false,
  tabIndex,
  role,
  "aria-controls": ariaControls,
  "aria-expanded": ariaExpanded,
  "aria-haspopup": ariaHaspopup,
}: ButtonProps) {
  const buttonClass = `button-${variant}${
    fullWidth ? " fullWidth" : ""
  } ${className}`.trim();

  return (
    <StyledButton
      onClick={onClick}
      type={type}
      className={buttonClass}
      variant={variant}
      fullWidth={fullWidth}
      aria-label={ariaLabel}
      disabled={disabled}
      tabIndex={tabIndex}
      role={role}
      aria-controls={ariaControls}
      aria-expanded={ariaExpanded}
      aria-haspopup={ariaHaspopup}
    >
      {children}
      {icon && <img src={icon} alt={iconAlt || ""} aria-hidden={!iconAlt} />}
    </StyledButton>
  );
}

export default Button;
